module.exports = __webpack_public_path__ + "img/abclogo.7778e3bd.png";